// this file added by Bearer Web Developer
import React from "react";
import riderIcon from "../../../assets/images/rider-icon.svg";
// import { Marker } from "@react-google-maps/api";
import { OverlayView } from "@react-google-maps/api";
import { observer } from "mobx-react-lite";
import { useAppState } from "../../../states/app-state";
import { Location } from "../../../states/riderState";
import styles from './riderMarkers.module.scss';

const RiderMarkers: React.FC = observer(() => {

    const appState = useAppState();
    const selectedOrder = appState.selectedOrder;
    const time = selectedOrder?.rider?.path?.time;
    return (
        <>
            {/* <Marker
                icon={{
                    url: riderIcon,
                    // anchor: new google.maps.Point(16, 32),
                    scaledSize: new google.maps.Size(32, 32)
                }}
                position={selectedOrder?.rider.location as Location}
            /> */}
            <OverlayView
                position={selectedOrder?.rider.location as Location}
                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                getPixelPositionOffset={(width, height) => ({
                    x: -width / 2,
                    // y: -32,
                    // y: 0,
                    y: -height,
                })}
            >
                <div className={styles.rider_marker} >
                    {/* time text box */}
                    {
                        time &&
                        <div className={styles.text_box}>
                            <p>{time?.split(' ')[0]} <span>{time?.split(' ')[1]}</span></p>
                            <div className={styles.polygon}>
                                <img src='/polygon-white.svg' alt="" width={29} height={57} />
                            </div>
                        </div>
                    }
                    {/* animated icon */}
                    <div>
                        <img className={styles.pulse_orange} src={riderIcon} alt="rider" width={32} height={32} />
                    </div>
                </div>
            </OverlayView>
        </>
    )
})
export default RiderMarkers